<template>
  <div class="app">
    <router-view class="Router" />
  </div>
</template>

<script>
import ls from "./store/LStorage";
import baseFunc from "./util/base";
import vue from "vue";
var wx = require("weixin-js-sdk");
import { Toast } from "mint-ui";
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    this.fun(document, window);
    //固定在底部的按钮在input获得焦点是隐藏。
    let h = document.body.scrollHeight;
    window.addEventListener("resize", () => {
      let btn = document.getElementsByClassName("btn-position")[0];
      if (btn)
        if (document.body.scrollHeight < h) {
          btn.style.display = "none";
        } else {
          btn.style.display = "block";
        }
    });
    if (typeof window.addEventListener != "undefined") {
      window.addEventListener(
        "popstate",
        function(e) {
          if (baseFunc.prototype.isAlipayOrWechat()) {
            if (window.history.length <= 1) {
              wx.closeWindow();
            }
          }
        },
        false
      );
    }
  },
  methods: {
    fun(doc, win) {
      var docEl = doc.documentElement,
        resizeEvt =
          "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function() {
          var clientWidth = docEl.clientWidth;
          if (!clientWidth) return;
          //这里是假设在375px宽度设计稿的情况下，1rem = 10px；
          docEl.style.fontSize = 10 * (clientWidth / 375) + "px";
        };
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
    },
    /**
     * 禁止浏览器下拉回弹
     */
    stopDrop() {
      var lastY; //最后一次y坐标点
      document.body.addEventListener("touchstart", function(event) {
        lastY = event.changedTouches[0].clientY; //点击屏幕时记录最后一次Y度坐标。
      });
      document.body.addEventListener("touchmove", function(event) {
        var y = event.changedTouches[0].clientY;
        var st = this.scrollTop; //滚动条高度
        if (y >= lastY && st <= 10) {
          //如果滚动条高度小于0，可以理解为到顶了，且是下拉情况下，阻止touchmove事件。
          lastY = y;
          event.preventDefault();
        }
        lastY = y;
      });
    }
  }
};
</script>

<style lang="scss">
@import "./sass/main";
@import "./sass/normalize";
.app {
  color: $font-main;
  height: 100%;
}
.Router {
  position: absolute;
  width: 100%;
 // overflow-y: auto; /* 或者scroll */
  -webkit-overflow-scrolling: touch; /* 解决ios滑动不流畅问题 */
  transition: all 0.8s ease;
}
</style>



// WEBPACK FOOTER //
// src/App.vue